export default {
    owner: 'Titular',
    dependent: 'Dependiente',
    birth: 'F. Nac: ',
    identification: 'Identificación ',
    age: 'Edad ',
    sex: 'Sexo',
    male: 'Masculino',
    female: 'Femenino',
    totalResults: ' Resultados encontrados',
    selectBeneficiary: 'Seleccione un beneficiario',
    notItemsFound: {
        title: 'No se han encontrado coincidencias',
        description: 'Revise los términos utilizados en la busqueda',
        descriptionPrefix: 'o intente una ',
        descriptionSufix:'nueva búsqueda'
    }
}